import axios from 'axios';
import { PostJandiPayload } from '../types';

// https://wh.jandi.com/connect-api/webhook/32701031/fc0590f21bd96544b22b3d43f7e75a7b
export const postJandiWebhook = async (
  payload: PostJandiPayload,
  target_room_id: string,
) => {
  try {
    axios.post(
      `https://wh.jandi.com/connect-api/webhook/32701031/${target_room_id}`,
      payload,
    );
  } catch (error) {
    console.error('postJandiWebhook error', error);
    return { code: -1, message: 'Error' };
  }
};
